import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Heart } from 'lucide-react';
import { images, siteInfo } from '@/data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--surface-dark)] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src={images.logo}
                alt="Maison Bengal & Coon"
                className="h-14 w-auto object-contain brightness-110"
              />
            </Link>
            <p className="text-[var(--text-light)] text-sm leading-relaxed mb-6">
              Élevage familial de Bengals et Maine Coons LOOF en Bretagne.
              Passion, qualité et bien-être animal au cœur de notre engagement.
            </p>
            {/* Royal Canin Partner */}
            <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg">
              <span className="text-xs text-[var(--text-light)]">Partenaire</span>
              <img
                src={images.royalCanin}
                alt="Royal Canin"
                className="h-8 w-auto object-contain brightness-110"
              />
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-serif text-lg font-medium mb-6 text-[var(--color-gold)]">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link text-sm">Accueil</Link>
              </li>
              <li>
                <Link to="/maine-coon" className="footer-link text-sm">Le Maine Coon</Link>
              </li>
              <li>
                <Link to="/elevage" className="footer-link text-sm">Notre Élevage</Link>
              </li>
              <li>
                <Link to="/livre-dor" className="footer-link text-sm">Livre d'Or</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link text-sm">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-serif text-lg font-medium mb-6 text-[var(--color-gold)]">
              Informations Légales
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/mentions-legales" className="footer-link text-sm">
                  Mentions Légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="footer-link text-sm">
                  Politique de Confidentialité
                </Link>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-white/10">
              <p className="text-xs text-[var(--text-light)]">
                SIRET: {siteInfo.siret}
              </p>
              <p className="text-xs text-[var(--text-light)] mt-1">
                Titulaires ACACED
              </p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg font-medium mb-6 text-[var(--color-gold)]">
              Contact
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${siteInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-start gap-3 text-[var(--text-light)] hover:text-[var(--color-gold)] transition-colors"
                >
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span className="text-sm">{siteInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="flex items-start gap-3 text-[var(--text-light)] hover:text-[var(--color-gold)] transition-colors"
                >
                  <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span className="text-sm">{siteInfo.email}</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-[var(--text-light)]">
                  <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span className="text-sm">
                    Plounéour-Ménez<br />
                    Finistère, Bretagne
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[var(--text-light)]">
              © {currentYear} Maison Bengal & Coon. Tous droits réservés.
            </p>
            <p className="text-sm text-[var(--text-light)] flex items-center gap-1">
              Fait avec <Heart className="w-4 h-4 text-[var(--color-gold)]" /> en Bretagne
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
